import store from "@frameworks/web/redux/store";
import { ACCOUNT_DETAILS, ACCOUNT_DETAILS_ERROR, ACCOUNT_DETAILS_HIDE_ERROR, ACCOUNT_DETAILS_START_LOADER, ACCOUNT_DETAILS_STOP_LOADER, } from "../interface/IGetAccountDetails";
class GetAccountDetailsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getAccountDetails(data) {
        this.dispatch({
            type: ACCOUNT_DETAILS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: ACCOUNT_DETAILS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: ACCOUNT_DETAILS_HIDE_ERROR,
        });
    }
    getAccountDetailloader() {
        this.dispatch({
            type: ACCOUNT_DETAILS_START_LOADER,
        });
    }
    getAccountDetailStopLoader() {
        this.dispatch({
            type: ACCOUNT_DETAILS_STOP_LOADER,
        });
    }
}
export default GetAccountDetailsActions;
